import InvoiceApproval from './InvoiceApproval'

export default InvoiceApproval
